<template>
  <div class="km-page">
    <header class="km-top">
      <button class="km-back" @click="back()" aria-label="Back">
        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>
      </button>
      <div class="km-top__title"><span class="km-top__dot"></span><h1>{{ $t('setting.language') }}</h1></div>
      <div style="width:38px"></div>
    </header>

    <main class="km-main">
      <section class="km-section">
        <div class="km-sec-head">{{ $t('language_page.heading') }}</div>
        <div class="km-card">
          <button
            v-for="item in langs" :key="item.code"
            class="km-row" :class="{ active: lang === item.code }"
            @click="changeLang(item.code)"
          >
            <span class="km-row__ico" :style="{ background: item.color, fontFamily: 'system-ui, sans-serif', fontSize: '15px', fontWeight: 700 }">
              {{ item.flag }}
            </span>
            <div class="km-lang-body">
              <span class="km-lang-name">{{ item.name }}</span>
              <span class="km-lang-native">{{ item.native }}</span>
            </div>
            <span class="km-row__radio"></span>
          </button>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import { Toast } from "vant";
import { LANGUAGE_OPTIONS, applySiteLocale } from '@/common/locale';
export default {
  name: "Language",
  data() {
    return {
      lang: this.$i18n.locale || 'en',
      source: '',
      langs: LANGUAGE_OPTIONS
    };
  },
  created() { this.lang = this.$i18n.locale; },
  mounted() { this.source = this.$route.params.type; },
  methods: {
    back() { return window.history.back(); },
    replaceLang() {
      this.$http({ method: "get", url: "replaceLang", data: { lang: this.lang } }).then(() => {});
    },
    changeLang(code) {
      Toast.loading({ duration: 400 });
      this.lang = applySiteLocale(this.$i18n, code);
      this.replaceLang().then(() => {
        Toast.success(this.$t('language_page.saved'));
        setTimeout(() => {
          if (this.source === 'setting') window.location.href = '/#/Mine';
          else window.location.reload();
        }, 350);
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "./_km-page.less";
.km-lang-body { flex: 1; display: flex; flex-direction: column; }
.km-lang-name { font-size: 14px; font-weight: 700; color: #2a1a3f; }
.km-lang-native { font-size: 11px; color: #8d7fa6; margin-top: 2px; text-transform: uppercase; letter-spacing: .05em; }
.km-row.active .km-lang-name { color: #ff4d8d; }
</style>
